import { MonitoreoComponent } from './../monitoreo/monitoreo.component';
import { UsuariosModule } from './../usuarios/usuarios.module';
import { TelefonosModule } from './../telefonos/telefonos.module';
import { MicromedidoresModule } from './../micromedidores/micromedidores.module';
import { MedidoresModule } from './../medidores/medidores.module';
import { VehiculosModule } from './../vehiculos/vehiculos.module';
import { ClientesModule } from './../clientes/clientes.module';
import { DispositivosModule } from './../dispositivos/dispositivos.module';
import { SimsModule } from './../sims/sims.module';
import { TableroModule } from './../tablero/tablero.module';
import { MonitoreoModule } from './../monitoreo/monitoreo.module';
import { NgxPermissionsModule } from 'ngx-permissions';
// Angular
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
	MatAutocompleteModule,
	MatButtonModule,
	MatCardModule,
	MatCheckboxModule,
	MatDatepickerModule,
	MatDialogModule,
	MatIconModule,
	MatInputModule,
	MatMenuModule,
	MatNativeDateModule,
	MatPaginatorModule,
	MatProgressBarModule,
	MatProgressSpinnerModule,
	MatRadioModule,
	MatSelectModule,
	MatSnackBarModule,
	MatSortModule,
	MatTableModule,
	MatTabsModule,
	MatTooltipModule,
	MatDividerModule
} from '@angular/material';
// NgBootstrap
import { NgbDropdownModule, NgbTabsetModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
// Perfect Scrollbar
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
// Core module
import { CoreModule } from '../../core/core.module';
// CRUD Partials
import {
	ActionNotificationComponent,
	AlertComponent,
	DeleteEntityDialogComponent,
	FetchEntityDialogComponent,
	UpdateStatusDialogComponent
} from './content/crud';
// Layout partials
import {
	ContextMenu2Component,
	ContextMenuComponent,
	LanguageSelectorComponent,
	NotificationComponent,
	QuickActionComponent,
	QuickPanelComponent,
	ScrollTopComponent,
	SearchDefaultComponent,
	SearchDropdownComponent,
	SearchResultComponent,
	SplashScreenComponent,
	StickyToolbarComponent,
	Subheader1Component,
	Subheader2Component,
	Subheader3Component,
	Subheader4Component,
	Subheader5Component,
	SubheaderSearchComponent,
	UserProfile2Component,
	UserProfile3Component,
	UserProfileComponent,
} from './layout';
// General
import { NoticeComponent } from './content/general/notice/notice.component';
import { PortletModule } from './content/general/portlet/portlet.module';
// Errpr
import { ErrorComponent } from './content/general/error/error.component';
// Extra module
import { WidgetModule } from './content/widgets/widget.module';
// SVG inline
import { InlineSVGModule } from 'ng-inline-svg';
import { CartComponent } from './layout/topbar/cart/cart.component';
import { DxButtonModule, DxPopupModule, DxDataGridModule, DxCheckBoxModule, DxSelectBoxModule, DxTreeListModule, DxFormModule, DxDateBoxModule } from 'devextreme-angular';
//import { GeocercasComponent } from '../monitoreo/geocercas/geocercas.component';
//import { ReportePosicionesComponent } from '../monitoreo/vehiculos/reporte-posiciones/reporte-posiciones.component';
//import { DxiItemModule } from 'devextreme-angular/ui/nested/item-dxi';
//import { GuardarGeocercasComponent } from '../monitoreo/guardar-geocercas/guardar-geocercas.component';
//import { AdministracionModule } from '../administracion/administracion.module';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { CdkTableModule } from '@angular/cdk/table';
import { CdkTreeModule } from '@angular/cdk/tree';
import {DragDropModule} from '@angular/cdk/drag-drop';
import { InformacionVehiculoComponent } from '../monitoreo/components/popups/vehiculos/informacion-vehiculo/informacion-vehiculo.component';
import { ConsolaModule } from '../consola/consola.module';
import { BrowserModule } from '@angular/platform-browser';
//import { ModalPositionCache } from '../monitoreo/popus/street-view/cache-popup/modal-position.cache';
//import { MicromedidoresComponent } from '../monitoreo/micromedidores/micromedidores.component';
@NgModule({
	declarations: [
		ScrollTopComponent,
		NoticeComponent,
		ActionNotificationComponent,
		DeleteEntityDialogComponent,
		FetchEntityDialogComponent,
		UpdateStatusDialogComponent,
		AlertComponent,
		ContextMenu2Component,
		ContextMenuComponent,
		QuickPanelComponent,
		ScrollTopComponent,
		SearchResultComponent,
		SplashScreenComponent,
		StickyToolbarComponent,
		Subheader1Component,
		Subheader2Component,
		Subheader3Component,
		Subheader4Component,
		Subheader5Component,
		SubheaderSearchComponent,
		LanguageSelectorComponent,
		NotificationComponent,
		QuickActionComponent,
		SearchDefaultComponent,
		SearchDropdownComponent,
		UserProfileComponent,
		UserProfile2Component,
		UserProfile3Component,
		CartComponent,
		ErrorComponent
	],
	exports: [
		WidgetModule,
		PortletModule,

		ScrollTopComponent,
		NoticeComponent,
		ActionNotificationComponent,
		DeleteEntityDialogComponent,
		FetchEntityDialogComponent,
		UpdateStatusDialogComponent,
		AlertComponent,

		// topbar components
		ContextMenu2Component,
		ContextMenuComponent,
		QuickPanelComponent,
		ScrollTopComponent,
		SearchResultComponent,
		SplashScreenComponent,
		StickyToolbarComponent,
		Subheader1Component,
		Subheader2Component,
		Subheader3Component,
		Subheader4Component,
		Subheader5Component,
		SubheaderSearchComponent,
		LanguageSelectorComponent,
		NotificationComponent,
		QuickActionComponent,
		SearchDefaultComponent,
		SearchDropdownComponent,
		UserProfileComponent,
		UserProfile2Component,
		UserProfile3Component,
		CartComponent,
		ErrorComponent,
	],
	imports: [
		CommonModule,
		RouterModule,
		FormsModule,
		ReactiveFormsModule,
		PerfectScrollbarModule,
		InlineSVGModule,
		CoreModule,
		PortletModule,
		WidgetModule,
		DxButtonModule,
		// angular material modules
		MatButtonModule,
		MatMenuModule,
		MatSelectModule,
		MatInputModule,
		MatTableModule,
		MatAutocompleteModule,
		MatRadioModule,
		MatIconModule,
		MatNativeDateModule,
		MatProgressBarModule,
		MatDatepickerModule,
		MatCardModule,
		MatPaginatorModule,
		MatSortModule,
		MatCheckboxModule,
		MatProgressSpinnerModule,
		MatSnackBarModule,
		MatTabsModule,
		MatTooltipModule,
		MatDialogModule,
		// ng-bootstrap modules
		NgbDropdownModule,
		NgbTabsetModule,
		NgbTooltipModule,
		DxPopupModule,
		DxDataGridModule,
		MatDividerModule,
		DxSelectBoxModule,
		DxCheckBoxModule,
		DxTreeListModule,
		DxFormModule,
		DxButtonModule,
		FormsModule,
		//DxiItemModule,
		DxDateBoxModule,
		TableroModule,
		MonitoreoModule,
		SimsModule,
		DispositivosModule,
		ConsolaModule,
		//ClientesModule,
		//VehiculosModule,
		//MedidoresModule,
		//MicromedidoresModule,
		//TelefonosModule,
		//UsuariosModule,
		CdkStepperModule,
    CdkTableModule,
    CdkTreeModule,
		DragDropModule,
		NgxPermissionsModule


	],
	entryComponents:[
	],
	providers:[DatePipe, MonitoreoComponent]
})
export class PartialsModule {
}
